module.exports = __webpack_public_path__ + "img/anchovy.0826856d.png";